import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSupport = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_2698_1748)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12.5 10V12V13.5H10",
				stroke: "black",
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.5 12.5H8.5V14.5H10.5V12.5Z",
				stroke: "black",
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.5 10.5V6C12.5 3.51 10.49 1.5 8 1.5C5.51 1.5 3.5 3.51 3.5 6V10.5",
				stroke: "black",
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.5 7.5H3.5V11.5H2.5C1.95 11.5 1.5 11.05 1.5 10.5V8.5C1.5 7.95 1.95 7.5 2.5 7.5Z",
				stroke: "black",
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.5 11.5H12.5V7.5H13.5C14.05 7.5 14.5 7.95 14.5 8.5V10.5C14.5 11.05 14.05 11.5 13.5 11.5Z",
				stroke: "black",
				strokeLinejoin: "bevel"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2698_1748",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgSupport;
